import { Card, Typography } from "@mui/material";
import DangerHintBox from "./DangerHintBox";
import SearchBar from "./SearchBar";

export const AddressForm = () => {
  return (
    <>
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: { xs: '20px', sm: '40px' },
          maxWidth: { xs: '100%', sm: '600px' },
          width: '100%',
          height: "fit-content",
          gap: { xs: '30px', sm: '70px' },
          overflow: "hidden",
          boxSizing: 'border-box',
        }}
      >
        <Typography variant="h2"  textAlign="center">
          Vielen Dank, dass Sie eine Störung melden möchten. Wo befindet sich die Straßenleuchte?
        </Typography>
        <SearchBar />
        <DangerHintBox />
      </Card>
    </>
  );
};

export default AddressForm;
